import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const BOWER_LOGO = "https://customer-assets.emergentagent.com/job_9905ee30-c002-464f-b890-465ab6cc70dc/artifacts/9497g015_Bower%20School%20Logo-01.png";

// Indian States/Cities
const INDIAN_STATES_CITIES = {
  "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Tirupati"],
  "Bihar": ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur"],
  "Chhattisgarh": ["Raipur", "Bhilai", "Bilaspur"],
  "Delhi": ["New Delhi", "South Delhi", "North Delhi", "East Delhi", "West Delhi"],
  "Goa": ["Panaji", "Margao", "Vasco da Gama"],
  "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
  "Haryana": ["Gurugram", "Faridabad", "Panipat", "Ambala", "Sonipat"],
  "Jharkhand": ["Ranchi", "Jamshedpur", "Dhanbad"],
  "Karnataka": ["Bengaluru", "Mysuru", "Mangaluru", "Hubli"],
  "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior"],
  "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Navi Mumbai"],
  "Odisha": ["Bhubaneswar", "Cuttack", "Rourkela"],
  "Punjab": ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Mohali"],
  "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Salem"],
  "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Noida", "Ghaziabad"],
  "Uttarakhand": ["Dehradun", "Haridwar", "Roorkee"],
  "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Siliguri"],
  "Chandigarh": ["Chandigarh"],
  "Jammu and Kashmir": ["Srinagar", "Jammu"],
};
const INDIAN_STATES = Object.keys(INDIAN_STATES_CITIES).sort();

const DESIGNATION_OPTIONS = [
  "-Select-",
  "Principal / Head of School",
  "Vice Principal",
  "Founder / Director",
  "Academic Coordinator",
  "Head of Department",
  "School Administrator",
  "Finance Manager",
  "Procurement Officer",
  "Faculty",
];

// School partner logos from bowerschool.com
const SCHOOL_LOGOS = [
  { name: "CHIREC International", url: "https://bowerschool.com/_next/image?url=%2F78a36cd6bc3e7c09a74cb591e4aafeacdcb7f017.png&w=256&q=75" },
  { name: "Sreenidhi International", url: "https://bowerschool.com/_next/image?url=%2F0f4edbccf6a6d0c4025beaa4f6cd86cb00a6b758.png&w=256&q=75" },
  { name: "Oakridge International", url: "https://bowerschool.com/_next/image?url=%2Fef840a17b5ede871c34f9cb02ff20ba926e41ad9.png&w=256&q=75" },
  { name: "The Shri Ram Academy", url: "https://bowerschool.com/_next/image?url=%2F75cc87d9efd998e6a72fcc40c9c2622386b48c3a.png&w=128&q=75" },
  { name: "Gaudium School", url: "https://bowerschool.com/_next/image?url=%2F86d0a70295ec669334eccbd1d9c316cc7d48a1e4.png&w=128&q=75" },
  { name: "Kairos International", url: "https://bowerschool.com/_next/image?url=%2F604c5b53f0b4b6eecd7b72925ed7dc35fd1e420d.png&w=96&q=75" },
  { name: "Manchester Global", url: "https://bowerschool.com/_next/image?url=%2F056cd725ee1b5b784d7cd65b905e9f4c686d0add.png&w=640&q=75" },
  { name: "VIP's International", url: "https://bowerschool.com/_next/image?url=%2F0c19e2d966e7a9c9cf8d5c5d7afcbd9b52405ae6.png&w=256&q=75" },
  { name: "Meridian School", url: "https://bowerschool.com/_next/image?url=%2Ff4337c09819821e1ed64c874705836644596d0e8.png&w=256&q=75" },
  { name: "The Millennium School", url: "https://bowerschool.com/_next/image?url=%2F8e3deaad95fda93eecf33c9b372eb37f3d2e3247.png&w=256&q=75" },
  { name: "Partner School", url: "https://bowerschool.com/_next/image?url=%2Fbb670be7294ba3e19e060e5f5e426bd97519989e.png&w=256&q=75" },
  { name: "School Partner", url: "https://bowerschool.com/_next/image?url=%2Fa2d16c3b8923c73bf763f7e59df36f314b42577d.png&w=256&q=75" },
];


// Zoho form action URL (from the official Zoho HTML export)
const ZOHO_FORM_ACTION = "https://forms.zohopublic.in/bowereducationalservicespriv1/form/SEEDbyBowerB2BPartnershipInterestFormLandingPage/formperma/iEJ3J4GyieE0Z_4AwKv2GOHr9sE1vyznYwgALjFBOn0/htmlRecords/submit";

// ===== PARTNERSHIP FORM =====
const PartnershipForm = () => {
  const [formData, setFormData] = useState({
    school_name: "", first_name: "", last_name: "", designation: "-Select-",
    email: "", phone: "", state: "", city: "",
  });
  const [availableCities, setAvailableCities] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const formRef = useRef(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (formData.state && INDIAN_STATES_CITIES[formData.state]) {
      setAvailableCities(INDIAN_STATES_CITIES[formData.state]);
    } else {
      setAvailableCities([]);
    }
  }, [formData.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "state") {
      setFormData(prev => ({ ...prev, state: value, city: "" }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.school_name || !formData.email || formData.designation === "-Select-") return;
    setIsSubmitting(true);

    // Build a hidden form that POSTs directly to Zoho with exact field names
    const form = document.createElement("form");
    form.method = "POST";
    form.action = ZOHO_FORM_ACTION;
    form.target = "zoho_seed_hidden_frame";
    form.enctype = "multipart/form-data";
    form.acceptCharset = "UTF-8";
    form.style.display = "none";

    // Helper to read UTM cookie values if Zoho tracking script is loaded
    const getUTM = (param) => {
      try {
        if (window.zfutm_zfLead) return window.zfutm_zfLead.zfutm_gC(param) || "";
      } catch (_) {}
      return "";
    };

    // Exact Zoho field names from the official HTML form export
    const fields = {
      zf_referrer_name: "",
      zf_redirect_url: "",
      zc_gad: "",
      utm_source: getUTM("utm_source"),
      utm_medium: getUTM("utm_medium"),
      utm_campaign: getUTM("utm_campaign"),
      utm_term: getUTM("utm_term"),
      utm_content: getUTM("utm_content"),
      SingleLine: formData.school_name,
      Name1_First: formData.first_name,
      Name1_Last: formData.last_name,
      Dropdown: formData.designation,
      Email: formData.email,
      PhoneNumber_countrycodeval: "+91",
      PhoneNumber_countrycode: formData.phone,
      Address_Region: formData.state,
      Address_City: formData.city,
    };

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);

    // Listen for the hidden iframe to finish loading (Zoho response)
    const onLoad = () => {
      cleanup();
      setIsSubmitting(false);
      setIsSubmitted(true);
    };

    const cleanup = () => {
      if (form.parentNode) form.parentNode.removeChild(form);
      if (iframeRef.current) iframeRef.current.removeEventListener("load", onLoad);
    };

    if (iframeRef.current) {
      iframeRef.current.addEventListener("load", onLoad);
    }

    form.submit();

    // Fallback: show success after 5s even if iframe doesn't fire load
    setTimeout(() => {
      cleanup();
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 5000);
  };

  if (isSubmitted) {
    return (
      <div ref={formRef} className="text-center py-10" data-testid="seed-form-success">
        <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 bg-green-100">
          <span className="material-symbols-outlined text-3xl text-green-600">check_circle</span>
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">Thank You!</h3>
        <p className="text-sm text-gray-500">Our partnerships team will reach out within 24 hours.</p>
      </div>
    );
  }

  const inputCls = "w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 text-sm text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-orange-400 focus:border-transparent outline-none transition-all";
  const labelCls = "block text-[11px] font-bold uppercase tracking-wider text-gray-500 mb-1.5 ml-1";
  const selectCls = "w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 text-sm text-gray-900 focus:ring-2 focus:ring-orange-400 focus:border-transparent outline-none appearance-none cursor-pointer";

  return (
    <div ref={formRef}>
      <iframe ref={iframeRef} name="zoho_seed_hidden_frame" style={{ display: "none" }} title="SEED Form Submit" />
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="seed-partnership-form">
        <div>
          <label className={labelCls}>School Name <span className="text-orange-500">*</span></label>
          <input name="school_name" value={formData.school_name} onChange={handleChange} placeholder="e.g., Delhi Public School" required className={inputCls} data-testid="seed-input-school" />
        </div>
        <div>
          <label className={labelCls}>Contact Person</label>
          <div className="grid grid-cols-2 gap-3">
            <input name="first_name" value={formData.first_name} onChange={handleChange} placeholder="First Name" className={inputCls} data-testid="seed-input-firstname" />
            <input name="last_name" value={formData.last_name} onChange={handleChange} placeholder="Last Name" className={inputCls} data-testid="seed-input-lastname" />
          </div>
        </div>
        <div>
          <label className={labelCls}>Designation <span className="text-orange-500">*</span></label>
          <select name="designation" value={formData.designation} onChange={handleChange} required className={selectCls} data-testid="seed-select-designation">
            {DESIGNATION_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Email <span className="text-orange-500">*</span></label>
          <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="school@example.com" required className={inputCls} data-testid="seed-input-email" />
        </div>
        <div>
          <label className={labelCls}>Phone</label>
          <div className="flex gap-2">
            <div className="flex items-center gap-1.5 rounded-xl px-3 py-3 bg-gray-50 border border-gray-200 shrink-0 text-sm text-gray-700">
              <span>{"\ud83c\uddee\ud83c\uddf3"}</span> +91
            </div>
            <input name="phone" value={formData.phone} onChange={handleChange} placeholder="10-digit number" maxLength={10} className={inputCls} data-testid="seed-input-phone" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className={labelCls}>State</label>
            <select name="state" value={formData.state} onChange={handleChange} className={selectCls} data-testid="seed-select-state">
              <option value="">Select State</option>
              {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className={labelCls}>City</label>
            <select name="city" value={formData.city} onChange={handleChange} disabled={!formData.state} className={selectCls} style={{ opacity: formData.state ? 1 : 0.5 }} data-testid="seed-select-city">
              <option value="">{formData.state ? "Select City" : "State first"}</option>
              {availableCities.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>
        <button type="submit" disabled={isSubmitting} className="w-full py-4 rounded-xl text-white font-bold text-base flex items-center justify-center gap-2 transition-all active:scale-[0.98] shadow-lg shadow-orange-200" style={{ background: "linear-gradient(135deg, #F97316, #EA580C)" }} data-testid="seed-form-submit-btn">
          {isSubmitting ? <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" /> : (
            <>Partner With Us <span className="material-symbols-outlined text-xl">arrow_forward</span></>
          )}
        </button>
        <p className="text-[10px] text-center text-gray-400 mt-2">
          By submitting, you agree to Bower's <a href="https://bowerschool.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline">Privacy Policy</a>.
        </p>
      </form>
    </div>
  );
};


// ===== MAIN PAGE =====
const SeedPartnershipPage = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }} data-testid="seed-partnership-page">
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-white/80 backdrop-blur-xl border-b border-gray-100">
        <div className="flex justify-between items-center max-w-7xl mx-auto px-4 md:px-8 py-3">
          <div className="flex items-center gap-8">
            <Link to="/" data-testid="seed-logo-link">
              <img src={BOWER_LOGO} alt="Bower School" className="h-10 md:h-12 object-contain" />
            </Link>
            <div className="hidden md:flex items-center gap-1 text-xs font-semibold text-gray-400">
              <span>Programs</span>
              <span className="material-symbols-outlined text-sm">chevron_right</span>
              <span className="text-orange-600">SEED for Schools</span>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/events" className="hidden md:block text-sm font-semibold text-gray-600 hover:text-gray-900 transition-colors">Events</Link>
            <a href="https://bowerschool.com" target="_blank" rel="noopener noreferrer" className="hidden md:block text-sm font-semibold text-gray-600 hover:text-gray-900 transition-colors">About</a>
            <button onClick={() => document.getElementById("seed-form")?.scrollIntoView({ behavior: "smooth" })} className="px-5 py-2 rounded-full text-sm font-bold text-white shadow-md" style={{ background: "linear-gradient(135deg, #F97316, #EA580C)" }} data-testid="seed-nav-cta">
              Partner With Us
            </button>
          </div>
        </div>
      </nav>

      {/* ===== HERO ===== */}
      <section className="pt-24 md:pt-28 pb-12 md:pb-16 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full blur-[120px] -translate-y-1/2 translate-x-1/4" style={{ background: "rgba(249,115,22,0.06)" }} />
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            {/* Left */}
            <div className="lg:col-span-7 order-last lg:order-first">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-orange-50 text-orange-600 border border-orange-100 mb-6">
                <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" />
                In-School Program &middot; Grades 3&ndash;12
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight leading-[1.1] mb-6" data-testid="seed-hero-title">
                Bring <span className="text-orange-600">Entrepreneurship</span> Into Your School
              </h1>
              <p className="text-lg md:text-xl text-gray-500 max-w-xl mb-10 leading-relaxed">
                SEED is Bower's structured, in-school entrepreneurship program &mdash; a capability layer that integrates into existing school schedules. Zero disruption. Practitioner-led. Future-ready outcomes.
              </p>
              <div className="flex flex-wrap gap-4 mb-12">
                {[
                  { icon: "school", label: "20 In-School Sessions" },
                  { icon: "view_module", label: "Module-Based Learning" },
                  { icon: "person", label: "Practitioner-Led" },
                ].map((t, i) => (
                  <div key={i} className="flex items-center gap-2.5 px-4 py-2.5 rounded-xl bg-gray-50 border border-gray-100">
                    <span className="material-symbols-outlined text-orange-500 text-lg">{t.icon}</span>
                    <span className="text-sm font-semibold text-gray-700">{t.label}</span>
                  </div>
                ))}
              </div>
              {/* Quick stats */}
              <div className="grid grid-cols-3 gap-6 max-w-md">
                {[
                  { num: "5,500+", label: "Students Trained" },
                  { num: "45+", label: "School Partners" },
                  { num: "250+", label: "Student Projects" },
                ].map((s, i) => (
                  <div key={i}>
                    <div className="text-2xl md:text-3xl font-extrabold text-gray-900">{s.num}</div>
                    <div className="text-xs text-gray-400 font-medium mt-0.5">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: Form */}
            <div className="lg:col-span-5 lg:sticky lg:top-24 order-first lg:order-last" id="seed-form">
              <div className="p-6 md:p-8 rounded-2xl bg-white shadow-2xl shadow-gray-200/60 border border-gray-100">
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">Partner With Bower SEED</h3>
                  <p className="text-sm text-gray-500">Let us know about your school. We'll be in touch within 24 hours.</p>
                </div>
                <PartnershipForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHAT IS SEED? ===== */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">About the Program</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">What Is SEED?</h2>
            <p className="text-lg text-gray-500 leading-relaxed">
              SEED is Bower's structured, in-school entrepreneurship program &mdash; not a one-off workshop or guest lecture, but a <strong className="text-gray-700">capability layer</strong> integrated into existing school schedules. Zero disruption to your timetable, no extra prep for your teachers.
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            {[
              { icon: "schedule", title: "20 Sessions", desc: "Structured program across the academic year" },
              { icon: "public", title: "Pan-India", desc: "Schools across geographies" },
              { icon: "school", title: "In-School", desc: "Integrated into existing schedules" },
              { icon: "workspace_premium", title: "Certification", desc: "SEED certification & portfolio" },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-lg transition-shadow group">
                <div className="w-12 h-12 rounded-xl bg-orange-50 flex items-center justify-center mb-4 group-hover:bg-orange-100 transition-colors">
                  <span className="material-symbols-outlined text-orange-600">{item.icon}</span>
                </div>
                <h4 className="font-bold text-gray-900 mb-1">{item.title}</h4>
                <p className="text-sm text-gray-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== WHY SCHOOLS PARTNER ===== */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">For School Leaders</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">Why Schools Partner With Bower SEED</h2>
          <p className="text-lg text-gray-500 mb-16 max-w-2xl">Bower works alongside school leadership &mdash; not parallel to it. A long-term capability partner, not a one-off workshop vendor.</p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { num: "01", title: "Future-Ready Without Overload", desc: "Add future-readiness without academic overload. SEED integrates into existing school schedules with zero timetable disruption.", icon: "rocket_launch" },
              { num: "02", title: "Institutional Differentiation", desc: "Strengthen your school's positioning with a structured entrepreneurship program backed by practitioner-led learning.", icon: "trending_up" },
              { num: "03", title: "Real-World Exposure", desc: "Offer students safe access to founders, investors, and real businesses through the Bower ecosystem.", icon: "language" },
              { num: "04", title: "Confidence Over Credentials", desc: "Build student confidence, communication skills, and structured thinking \u2014 not just certificates and credentials.", icon: "psychology" },
              { num: "05", title: "Partnership-Led Model", desc: "Bower works alongside school leadership \u2014 not parallel to it. A long-term capability partner, not a one-off vendor.", icon: "handshake" },
              { num: "06", title: "NEP 2020 Aligned", desc: "NEP 2020 calls for experiential learning, critical thinking, and entrepreneurial mindset. SEED provides the structured execution path.", icon: "verified" },
            ].map((item, i) => (
              <div key={i} className="relative p-6 rounded-2xl border border-gray-100 hover:border-orange-200 hover:shadow-lg transition-all group">
                <span className="text-5xl font-extrabold absolute top-4 right-4 text-gray-100 group-hover:text-orange-50 transition-colors">{item.num}</span>
                <div className="w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center mb-4">
                  <span className="material-symbols-outlined text-orange-600">{item.icon}</span>
                </div>
                <h4 className="font-bold text-gray-900 text-lg mb-2">{item.title}</h4>
                <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== HOW IT WORKS ===== */}
      <section className="py-16 md:py-24 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-orange-400 mb-3 block">The Journey</span>
            <h2 className="text-3xl md:text-4xl font-extrabold mb-4">How It Works</h2>
            <p className="text-gray-400 max-w-xl mx-auto">Each SEED journey ends with students presenting their ideas, building confidence and ownership over their thinking.</p>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            {[
              { step: "1", title: "Mindset & Orientation", desc: "Foundational entrepreneurial mindset building and orientation to design thinking.", icon: "psychology" },
              { step: "2", title: "Problem Framing & Case Exploration", desc: "Identify real problems, frame challenges, and explore real-world cases through hands-on activities.", icon: "search" },
              { step: "3", title: "Ideation, Prototyping & Iteration", desc: "Articulate ideas, build prototypes through team-based exploration and iterative feedback.", icon: "architecture" },
              { step: "4", title: "Showcase & Capability Mapping", desc: "Present ideas to mentors, earn SEED certification, and map capabilities for future readiness.", icon: "emoji_events" },
            ].map((item, i) => (
              <div key={i} className="relative rounded-2xl p-6 border border-gray-800 hover:border-orange-500/30 transition-all group" style={{ background: "#111827" }}>
                <div className="text-5xl font-black text-gray-800 group-hover:text-orange-900/30 transition-colors mb-4">{item.step}</div>
                <div className="w-10 h-10 rounded-lg bg-orange-500/10 flex items-center justify-center mb-4">
                  <span className="material-symbols-outlined text-orange-400">{item.icon}</span>
                </div>
                <h4 className="font-bold text-white text-lg mb-2">{item.title}</h4>
                <p className="text-sm text-gray-400 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== WHAT STUDENTS WALK AWAY WITH ===== */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">Outcomes</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">What Students Actually Walk Away With</h2>
            <p className="text-lg text-gray-500">Students don't leave with just ideas. They leave with confidence, structured thinking, and real-world exposure. Impact is measured in clarity, confidence, and capability &mdash; not marks.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: "flag", title: "Confidence to Start from Zero", desc: "Begin with nothing but an idea and develop the conviction to pursue it through structured frameworks and real-world exposure." },
              { icon: "record_voice_over", title: "Clear Communication Skills", desc: "Master the art of articulating ideas through presentations, storytelling, pitching, and team collaboration." },
              { icon: "account_tree", title: "Structured Thinking Frameworks", desc: "Learn to think systematically \u2014 from problem identification to business modelling, market analysis, and idea validation." },
              { icon: "autorenew", title: "Comfort with Failure & Iteration", desc: "Develop resilience by learning to prototype, test, fail safely, and iterate \u2014 building comfort with ambiguity." },
              { icon: "star", title: "Ownership of Learning", desc: "Take charge of ideas, lead teams, make decisions, and build a portfolio of real projects and prototypes." },
              { icon: "workspace_premium", title: "SEED Certification & Portfolio", desc: "Earn a recognized SEED certification and build a capability portfolio that demonstrates real-world readiness." },
            ].map((item, i) => (
              <div key={i} className="p-6 rounded-2xl bg-orange-50/50 border border-orange-100 hover:bg-orange-50 transition-colors">
                <span className="material-symbols-outlined text-orange-600 text-2xl mb-3 block">{item.icon}</span>
                <h4 className="font-bold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== THE SHIFT ===== */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">The Context</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">The Shift We Are Living In</h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">The gap today is no longer academic. It is behavioural, cognitive, and real-world readiness. Bower SEED bridges this gap.</p>
          </div>
          <div className="grid md:grid-cols-2 gap-10">
            {/* Today's Students Will... */}
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center"><span className="material-symbols-outlined text-green-600 text-sm">arrow_upward</span></span>
                Today's Students Will...
              </h3>
              <div className="space-y-4">
                {[
                  { title: "Work Across Multiple Careers", desc: "Navigate multiple career paths, not a single linear trajectory." },
                  { title: "Enter Jobs That Don't Yet Exist", desc: "Over 65% of future jobs demand problem-solving and adaptability over credentials." },
                  { title: "Compete in an Ideas-Driven World", desc: "Success depends on ideas, adaptability, and execution \u2014 not memorization." },
                  { title: "Need Structured Thinking Early", desc: "Entrepreneurship develops decision-making under uncertainty and risk awareness." },
                  { title: "Require Ownership & Accountability", desc: "Early exposure significantly improves confidence, communication, and initiative." },
                  { title: "Cannot Wait Until College", desc: "These are early-life skills. This work cannot wait till college." },
                ].map((item, i) => (
                  <div key={i} className="flex gap-3 p-4 rounded-xl bg-white border border-gray-100">
                    <span className="material-symbols-outlined text-green-500 mt-0.5 shrink-0">check_circle</span>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-sm">{item.title}</h4>
                      <p className="text-xs text-gray-500 mt-0.5">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Yet Schools Still Optimise For... */}
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center"><span className="material-symbols-outlined text-red-500 text-sm">warning</span></span>
                Yet Schools Still Optimise For...
              </h3>
              <div className="space-y-4">
                {[
                  { title: "Syllabus Completion Focus", desc: "Rote memorization, rigid syllabi, and exam-driven metrics that measure memory, not understanding." },
                  { title: "Marks & Predictability", desc: "Chasing grades and ranks while neglecting creativity, confidence, and long-term thinking." },
                  { title: "Linear Definitions of Success", desc: "One-size-fits-all curriculum ignoring unique interests, strengths, and aspirations." },
                  { title: "One-Off Workshops", desc: "Guest lectures and extracurricular add-ons that create awareness but not lasting capability." },
                  { title: "Theory-Only Instruction", desc: "Passive listening and note-taking with limited space for experimentation and real-world challenges." },
                  { title: "No NEP 2020 Execution Path", desc: "NEP 2020 calls for experiential learning and entrepreneurial mindset \u2014 but few schools have a structured way to execute it." },
                ].map((item, i) => (
                  <div key={i} className="flex gap-3 p-4 rounded-xl bg-white border border-gray-100">
                    <span className="material-symbols-outlined text-red-400 mt-0.5 shrink-0">cancel</span>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-sm">{item.title}</h4>
                      <p className="text-xs text-gray-500 mt-0.5">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CURRICULUM ===== */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">Curriculum</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">Three Program Tracks</h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">Each track is designed for two age bands &mdash; Junior (Grades 3&ndash;5) and Senior (Grades 6&ndash;12). Every level builds naturally upon the previous one.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: "computer", title: "Technology & Entrepreneurship", color: "#2563EB",
                junior: ["Creative thinking & empathy", "Basic prototyping & storytelling", "Product-building & team projects", "Pitching & mini business stalls"],
                senior: ["Market research & customer personas", "MVP creation & user journey mapping", "Brand identity & go-to-market strategy", "Digital marketing & investor pitching"],
              },
              {
                icon: "account_balance", title: "Economics & Finance", color: "#059669",
                junior: ["What is money & budgeting basics", "Smart spending & digital payments", "Profit & loss & pricing basics", "Savings, banking & consumer rights"],
                senior: ["Financial planning & debt management", "Stock market, shares & mutual funds", "Diversification & portfolio analysis", "ESG investing & corporate finance"],
              },
              {
                icon: "design_services", title: "Design Thinking & Prototyping", color: "#9333EA",
                junior: ["Observe problems & user needs", "Sketch & simple prototypes", "Nature-inspired design ideas", "Prototype refinement & real-world testing"],
                senior: ["Eco-design & sustainable solutions", "Systems thinking & root cause analysis", "Community problem-solving", "Impact storytelling & user testing"],
              },
            ].map((track, i) => (
              <div key={i} className="rounded-2xl border border-gray-100 overflow-hidden hover:shadow-lg transition-shadow">
                <div className="p-6" style={{ background: track.color + "08" }}>
                  <span className="material-symbols-outlined text-3xl mb-3 block" style={{ color: track.color }}>{track.icon}</span>
                  <h3 className="text-xl font-bold text-gray-900">{track.title}</h3>
                </div>
                <div className="p-6 space-y-6">
                  <div>
                    <span className="text-[10px] font-bold uppercase tracking-widest text-gray-400">Grades 3&ndash;5 (Junior)</span>
                    <ul className="mt-2 space-y-2">
                      {track.junior.map((item, j) => (
                        <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                          <span className="material-symbols-outlined text-sm mt-0.5" style={{ color: track.color }}>check</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <span className="text-[10px] font-bold uppercase tracking-widest text-gray-400">Grades 6&ndash;12 (Senior)</span>
                    <ul className="mt-2 space-y-2">
                      {track.senior.map((item, j) => (
                        <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                          <span className="material-symbols-outlined text-sm mt-0.5" style={{ color: track.color }}>check</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== TRUSTED BY SCHOOLS ===== */}
      <section className="py-16 md:py-20 bg-gray-50 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-2">Trusted by 45+ Schools Across India</h2>
          <p className="text-gray-500">Leading institutions partner with Bower SEED</p>
        </div>
        {/* Marquee */}
        <div className="relative">
          <div className="flex gap-12 animate-marquee">
            {[...SCHOOL_LOGOS, ...SCHOOL_LOGOS].map((logo, i) => (
              <div key={i} className="shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all opacity-60 hover:opacity-100">
                <img src={logo.url} alt={logo.name} className="max-h-14 max-w-28 object-contain" />
              </div>
            ))}
          </div>
        </div>
        <style>{`
          @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
          .animate-marquee { animation: marquee 40s linear infinite; min-width: max-content; }
        `}</style>
      </section>

      {/* ===== PRINCIPAL TESTIMONIALS ===== */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">What Schools Say</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">Principal Testimonials</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {[
              {
                quote: "We empower students beyond academics by fostering creativity and innovative thinking through ideation, financial literacy, project-based learning, and gamified lessons. Programs like Bower SEED introduce entrepreneurial skills, financial literacy, and design thinking early, with hands-on learning and mentorship.",
                name: "Lalitha Naidu",
                role: "Principal",
                school: "Meridian School",
              },
              {
                quote: "This program encourages younger students too, blending with regular teaching methods. We see students becoming more confident and solution-oriented. SEED has become a valuable part of our school ecosystem, and we look forward to continued partnership.",
                name: "Sireesha Koli",
                role: "Principal",
                school: "Sadhana Infinity International School",
              },
            ].map((t, i) => (
              <div key={i} className="p-8 rounded-2xl bg-orange-50/40 border border-orange-100">
                <span className="text-5xl font-black text-orange-200 leading-none block mb-4">&ldquo;</span>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">{t.quote}</p>
                <div>
                  <div className="font-bold text-gray-900">{t.name}</div>
                  <div className="text-xs text-gray-500">{t.role}, {t.school}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA BANNER ===== */}
      <section className="py-16 md:py-20">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="relative rounded-3xl p-10 md:p-16 overflow-hidden text-center text-white" style={{ background: "linear-gradient(135deg, #EA580C 0%, #F97316 50%, #FB923C 100%)" }}>
            <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 30% 50%, white 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
            <h2 className="text-3xl md:text-5xl font-extrabold mb-4 relative z-10">Give Your Students More Than Learning</h2>
            <p className="text-lg md:text-xl opacity-90 max-w-2xl mx-auto mb-8 relative z-10">Give them the ability to think, build, and lead. Partner with Bower SEED today.</p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 relative z-10">
              <button onClick={() => document.getElementById("seed-form")?.scrollIntoView({ behavior: "smooth" })} className="px-8 py-4 rounded-full font-bold text-lg bg-white text-orange-700 hover:scale-105 transition-transform shadow-xl" data-testid="seed-cta-partner">
                Partner With Us
              </button>
              <a href="https://bowerschool.com/programs/k12" target="_blank" rel="noopener noreferrer" className="px-8 py-4 rounded-full font-bold text-lg border-2 border-white/30 hover:bg-white/10 transition-colors">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CONTACT INFO ===== */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-sm text-gray-500">
            <a href="mailto:seed@bowerschool.com" className="flex items-center gap-2 hover:text-orange-600 transition-colors">
              <span className="material-symbols-outlined text-lg">mail</span> seed@bowerschool.com
            </a>
            <a href="tel:+919063172310" className="flex items-center gap-2 hover:text-orange-600 transition-colors">
              <span className="material-symbols-outlined text-lg">call</span> +91 90631 72310
            </a>
            <span className="flex items-center gap-2">
              <span className="material-symbols-outlined text-lg">location_on</span> Bower Campus, Hi-Tech City, Hyderabad
            </span>
          </div>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="py-16 px-4 md:px-8 bg-gray-900 text-white" data-testid="seed-footer">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
            <div className="col-span-2 md:col-span-1">
              <img src={BOWER_LOGO} alt="Bower School" className="h-12 md:h-14 object-contain brightness-0 invert mb-4" />
              <p className="text-sm text-gray-400 leading-relaxed">Building the next generation of industry disruptors.</p>
            </div>
            <div>
              <h4 className="font-bold text-xs uppercase tracking-widest mb-5 text-white">Programs</h4>
              <nav className="flex flex-col gap-3">
                <a href="/beat" className="text-sm text-gray-400 hover:text-white transition-colors">BEAT Test</a>
                <a href="/gitam" className="text-sm text-gray-400 hover:text-white transition-colors">GITAM x Bower BBA</a>
                <a href="/seed" className="text-sm text-gray-400 hover:text-white transition-colors">SEED for Schools</a>
                <a href="https://bowerschool.com/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors">3-Year BBA Programme</a>
                <a href="https://bowerschool.com/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors">Admissions</a>
              </nav>
            </div>
            <div>
              <h4 className="font-bold text-xs uppercase tracking-widest mb-5 text-white">Events</h4>
              <nav className="flex flex-col gap-3">
                <a href="/events" className="text-sm text-gray-400 hover:text-white transition-colors">All Events</a>
                <a href="/admin/events" className="text-sm text-gray-400 hover:text-white transition-colors">Manage Events</a>
              </nav>
            </div>
            <div>
              <h4 className="font-bold text-xs uppercase tracking-widest mb-5 text-white">Company</h4>
              <nav className="flex flex-col gap-3">
                <a href="https://bowerschool.com/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors">Home</a>
                <a href="https://bowerschool.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors">Terms of Service</a>
                <a href="https://bowerschool.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors">Privacy Policy</a>
                <a href="https://bowerschool.com/refund-policy" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors">Refund Policy</a>
              </nav>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-500">
            &copy; 2025 Bower School of Entrepreneurship. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SeedPartnershipPage;
